// Bounds.js
export const vancouverBounds = [
  [49.19854, -123.2247], // SouthWest corner
  [49.31691, -123.0237]  // NorthEast corner
];
